import { useMatches } from "react-router";

import { TRAIN_INSIGHTS_SELF_DEFINED_ROUTES } from "~/self-defined-routes";
import { type DeepReadonly } from "~/utils/types";

import { type RouteConfigEntry } from "@react-router/dev/routes";

const getCustomIds = (
  routeConfig?: DeepReadonly<RouteConfigEntry[]>,
): string[] => {
  return (
    routeConfig?.reduce<string[]>((acc: string[], route) => {
      return [
        ...acc,
        ...(route.id ? [route.id] : []),
        ...getCustomIds(route.children),
      ];
    }, []) || []
  );
};

export const useIsTrainInsights = () => {
  const matches = useMatches();
  const isTrainInsights = matches.some((match) =>
    getCustomIds(TRAIN_INSIGHTS_SELF_DEFINED_ROUTES).includes(match.id),
  );
  return { isTrainInsights };
};
